/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 1f61193df12d67d7b57107e1f742f23a6d8baaea95bb123b0e58db93afa8e34e
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Nav.style'

type NavOwnProps = {
  className?: string
  children?: React.ReactNode
  minimized?: boolean
}

export type NavProps = NavOwnProps & Omit<ComponentProps<'nav'>, keyof NavOwnProps>

function Nav(props: NavProps): ReactElement {
  const {
    children,
    className = '',
    minimized = false,
    ...rest
  } = props

  return (
    <nav
      className={cn('Nav', className, { minimized, 'not-minimized': !minimized })}
      css={style}
      {...rest}
      aria-label={rest['aria-label'] ?? 'Main navigation'}
    >
      {children}
    </nav>
  )
}

export default Nav
